/* eslint-disable no-unreachable */
/* eslint-disable no-nested-ternary */
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function CreateModal({
  createInput,
  createTextArea,
  createService,
  formData,
  getServiceList,
  history,
  showService,
  createUploader,
  creating,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      photo: _.get(formData, 'photo.cdnUrl'),
      icon_url: _.get(formData, 'icon_url.cdnUrl'),
    };
    return createService(args, ({ data }) => {
      setModal({ isOpen: false });
      getServiceList();
      history.push(`/smart-city-services/${_.get(data, 'id')}`);
      showService(data.id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };
  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row d-flex justify-content-center">
          <div className="col-md-6">
            <div className="col-12">
              <label className="form-control-plaintext form-label">
                Main Icon:{' '}
                <span className="text-danger">
                  <i>Required</i>
                </span>
              </label>
            </div>
            <div className="col-12">
              <img
                className="w-100 rounded"
                src={
                  !_.isObject(_.get(formData, 'photo') || '')
                    ? _.get(formData, 'photo') || ImagePlaceholder
                    : _.get(formData, 'photo.cdnUrl') || ImagePlaceholder
                }
                alt=""
              />
            </div>
            <div className="col-12 form-group">
              {createUploader(
                { key: 'photo', label: 'Browse' },
                { required: true, imagesOnly: true }
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="col-12">
              <label className="form-control-plaintext form-label">
                Inside Icon:{' '}
                <span className="text-danger">
                  <i>Required</i>
                </span>
              </label>
            </div>
            <div className="col-12">
              <img
                className="w-100 rounded"
                src={
                  !_.isObject(_.get(formData, 'icon_url') || '')
                    ? _.get(formData, 'icon_url') || ImagePlaceholder
                    : _.get(formData, 'icon_url.cdnUrl') || ImagePlaceholder
                }
                alt=""
              />
            </div>
            <div className="col-12 form-group">
              {createUploader(
                { key: 'icon_url', label: 'Browse' },
                { required: true, imagesOnly: true }
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'name', label: 'Name:' },
              {
                required: true,
                placeholder: 'Name',
                maxLength: '150',
              }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'link_url', label: 'Link:' },
              {
                required: true,
                placeholder: 'Link',
                maxLength: '150',
              }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'sequence', label: 'Sequence:' },
              {
                required: true,
                placeholder: 'Sequence',
                maxLength: '150',
                type: 'number',
              }
            )}
          </div>
          <div className="col-12 form-group">
            {createTextArea(
              { key: 'description', label: 'Description:' },
              { required: true, placeholder: 'Place content here' }
            )}
          </div>
          <div className="col-12 form-group">
            {createTextArea(
              { key: 'description_filipino', label: 'Tagalog Description:' },
              { placeholder: 'Place content here' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  createTextArea: PropTypes.instanceOf(Function).isRequired,
  getServiceList: PropTypes.instanceOf(Function).isRequired,
  createService: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showService: PropTypes.instanceOf(Function).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_SERVICE) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
